import WPNotice from "./notice";
// @ts-ignore
import $ from 'jquery';
var AddonDownload = /** @class */ (function () {
    function AddonDownload(el, slug) {
        this.element = el;
        this.slug = slug;
        this.loadingState = false;
        this.initEvents();
    }
    AddonDownload.prototype.getDownloadButton = function () {
        return this.element.querySelector('[data-install]');
    };
    AddonDownload.prototype.setLoadingState = function () {
        var button = this.getDownloadButton();
        if (button) {
            button.insertAdjacentHTML('afterend', '<span class="spinner" style="visibility: visible;"></span>');
            button.classList.add('button-disabled');
        }
        this.loadingState = true;
    };
    AddonDownload.prototype.removeLoadingState = function () {
        var button = this.getDownloadButton();
        var spinner = this.element.querySelector('.spinner');
        if (spinner) {
            spinner.remove();
        }
        if (button) {
            button.classList.remove('button-disabled');
        }
        this.loadingState = false;
    };
    AddonDownload.prototype.initEvents = function () {
        var _this = this;
        var button = this.getDownloadButton();
        if (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                if (_this.loadingState) {
                    return;
                }
                _this.setLoadingState();
                _this.download();
            });
        }
    };
    AddonDownload.prototype.success = function (status) {
        var button = this.getDownloadButton();
        var title = this.element.querySelector('h3');
        var notice = new WPNotice();
        notice.setMessage("<p>The Add-on <strong>" + title.innerHTML + "</strong> is installed.</p>")
            .makeDismissable()
            .addClass('updated');
        document.querySelector('.ac-addons').insertAdjacentElement('beforebegin', notice.render());
        if (button) {
            button.insertAdjacentHTML('beforebegin', "<span class=\"active\">" + status + "</span>");
            button.remove();
        }
    };
    AddonDownload.scrollToTop = function (ms) {
        $('html, body').animate({
            scrollTop: 0
        }, ms);
    };
    AddonDownload.prototype.failure = function (message) {
        var title = this.element.querySelector('h3');
        var notice = new WPNotice();
        notice.setMessage("<p><strong>" + title.innerHTML + "</strong>: " + message + "</p>")
            .makeDismissable()
            .addClass('notice-error');
        document.querySelector('.ac-addons').insertAdjacentElement('beforebegin', notice.render());
        AddonDownload.scrollToTop(200);
    };
    AddonDownload.prototype.download = function () {
        var _this = this;
        var request = this.request();
        request.done(function (response) {
            _this.removeLoadingState();
            if (response.success) {
                _this.success(response.data.status);
            }
            else {
                _this.failure(response.data);
            }
        });
    };
    AddonDownload.prototype.request = function () {
        var data = {
            action: 'acp-install-addon',
            plugin_name: this.slug,
            _ajax_nonce: AC._ajax_nonce
        };
        return $.ajax({
            url: ajaxurl,
            method: 'post',
            data: data
        });
    };
    return AddonDownload;
}());
export { AddonDownload };
